<template>
    <div class="publish-form">
        <div class="head display_flex align-center justify-between" :class="{'ios-head':iosnav}">
            <div class="back" @click="goback">
                <img src="../../../static/images/publish/back.png" alt class="back-icon" />
            </div>
            <div class="heade-title">
                <p class="title" v-if="page == 1 || page == 2">{{title}}({{page}}/2)</p>
                <p class="title" v-else>{{title}}</p>
                <p class="tip" v-if="page == 1 || page == 2">{{tip}}</p>
            </div>
            <div class="mine" @click="inquiry">
                <img
                    src="../../../static/images/publish/kefu-icon.png"
                    alt
                    class="mine-img"
                    v-if="page == 1 || page == 2"
                />
            </div>
        </div>
        <div class="form" v-if="page == 1" :class="{'ios-form':iosnav}">
            <div class="upFile">
                <div class="label-tip">上传商铺照片</div>
                <ul class="imgs display_flex">
                    <li class="img-item" v-for="(item,index) in params.imgs">
                        <img
                            src="../../../static/images/publish/closebtn.png"
                            alt
                            class="close"
                            @click="deleteImg(index)"
                        />
                        <van-image
                            class="img-info"
                            fit="fill"
                            :src="item"
                            @click="preview(params.imgs,index)"
                        />
                    </li>

                    <li class="add img-item">
                        <label for="add-input" class="add-label"></label>
                        <input
                            type="file"
                            id="add-input"
                            @change="updata($event)"
                            multiple
                            accept="image/*"
                        />
                    </li>
                </ul>
            </div>
            <div class="form-info">
                <div class="form-item" @click="showPopup('type')">
                    <div class="item-tip">商铺类型</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择商铺类型"
                            readonly
                            v-model="showOptions.type"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
                <div class="form-item" :class="{'active-border':active == 'area'}">
                    <div class="item-tip" :class="{'active-color':active == 'area'}">面积·㎡</div>
                    <div class="item-info display_flex justify-between align-center">
                        <van-field
                            v-model="params.build_area"
                            type="number"
                            placeholder="请输入面积"
                            @focus="focus('area')"
                            @blur="blur"
                            @input="params.build_area=params.build_area.replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3')"
                        />
                    </div>
                </div>
                <div class="form-item" :class="{'active-border':active == 'rent'}">
                    <div class="item-tip" :class="{'active-color':active == 'rent'}">月租金·元</div>
                    <div class="item-info display_flex justify-between align-center">
                        <van-field
                            v-model="params.monthly_rent"
                            type="number"
                            placeholder="请输入月租金"
                            @focus="focus('rent')"
                            @blur="blur"
                            @input="params.monthly_rent=params.monthly_rent.replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3')"
                        />
                    </div>
                </div>
                <div class="form-item" :class="{'active-border':active == 'turn'}">
                    <div class="item-tip" :class="{'active-color':active == 'turn'}">转让费·元</div>
                    <div class="item-info display_flex justify-between align-center">
                        <div class="face display_flex align-center">
                            <input
                                type="radio"
                                class="type"
                                name="type"
                                v-model="priceType"
                                value="0"
                                @change="radioChange"
                            />
                            <span>面议</span>
                        </div>
                        <div class="price display_flex align-center">
                            <input
                                type="radio"
                                class="type"
                                name="type"
                                v-model="priceType"
                                value="1"
                            />
                            <van-field
                                v-model="showOptions.turn"
                                type="number"
                                placeholder="请输入转让费"
                                class="price-input"
                                @focus="focus('turn')"
                                @blur="blur"
                                @input="showOptions.turn=showOptions.turn.replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3')"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-item" @click="showPopup('payType')">
                    <div class="item-tip">付款方式</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择付款方式"
                            readonly
                            v-model="showOptions.pay_ya + showOptions.pay_fu"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
                <div class="form-item" @click="showPopup('mapType')">
                    <div class="item-tip">地址</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请标记商铺所在位置"
                            readonly
                            v-model="params.real_address"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
                <div class="form-item" style="border-bottom:none;" @click="showPopup('areaType')">
                    <div class="item-tip">商圈</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择商铺所属商圈"
                            readonly
                            v-model="showOptions.areaName + showOptions.business_area_name"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
            </div>
        </div>
        <div class="form" v-if="page == 2" :class="{'ios-form':iosnav}">
            <div class="form-info">
                <div class="form-item" @click="showPopup('formatType')">
                    <div class="item-tip">当前经营</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择当前经营业态"
                            readonly
                            v-model="showOptions.parent_manage_type_name + showOptions.son_manage_type_name"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
                <div class="form-item" @click="showPopup('paperType')">
                    <div class="item-tip">证照</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择证照"
                            readonly
                            v-model="showOptions.license_name.join('/')"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
                <div class="form-item" @click="showPopup('floorType')">
                    <div class="item-tip">所在楼层</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择所在楼层"
                            readonly
                            v-model="showOptions.floor_name.join('/')"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
                <div class="form-item" @click="showPopup('floorType')">
                    <div class="item-tip">总楼层</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择总楼层"
                            readonly
                            v-model="showOptions.count_floor_name"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
                <div class="form-item" style="border-bottom:none;" @click="showPopup('supporType')">
                    <div class="item-tip">配套设施</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择配套设施"
                            readonly
                            v-model="showOptions.suppor_name.join('/')"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
            </div>
            <div class="form-info desc">
                <div class="form-item text" :class="{'active-border':active == 'title'}">
                    <div class="item-tip" :class="{'active-color':active == 'title'}">标题</div>
                    <textarea
                        class="project-title txt"
                        placeholder="请输入标题（10～40字）"
                        maxlength="40"
                        v-model="params.title"
                        @focus="focus('title')"
                        @blur="blur"
                    ></textarea>
                </div>
                <div class="form-item text" style="border-bottom:none;">
                    <div class="item-tip" :class="{'active-color':active == 'txt'}">描述</div>
                    <div class="textarea-wrapper">
                        <div class="content">{{params.introduce}}</div>
                        <textarea
                            class="project-tip txt"
                            placeholder="请输入描述"
                            maxlength="300"
                            v-model="params.introduce"
                            @focus="focus('txt')"
                            @blur="blur"
                        ></textarea>
                    </div>
                </div>
            </div>
            <div class="form-info desc">
                <div class="label-title display_flex justify-between align-center">
                    <div class="label-tip">选择特色标签</div>
                    <div class="label-num">{{params.characteristic.length}}/10</div>
                </div>
                <ul class="labels display_flex">
                    <li
                        class="label-item"
                        v-for="item in options.tag"
                        :class="{'label-active':params.characteristic.indexOf(item.id) != '-1'}"
                        @click="changeTag(item.id)"
                    >{{item.name}}</li>
                </ul>
            </div>
        </div>
        <!-- 证照 -->
        <div class="form" v-show="page == 3" :class="{'ios-form':iosnav}">
            <ul class="papers display_flex">
                <li
                    class="papers-item"
                    v-for="item in options.licence"
                    @click="changeOption(item.id,item.name)"
                >
                    <div class="papers-img">
                        <img src="../../../static/images/publish/papers.png" alt class="paper-info" />
                        <div
                            class="papered"
                            :class="{'papered-active':params.new_license.indexOf(item.id) != '-1'}"
                        ></div>
                    </div>
                    <div class="paper-tip">{{item.name}}</div>
                </li>
            </ul>
        </div>
        <!-- 设备配套 -->
        <div class="form" v-show="page == 4" :class="{'ios-form':iosnav}">
            <ul class="papers display_flex">
                <li
                    class="papers-item"
                    v-for="item in options.matching"
                    @click="changeOption(item.id,item.name)"
                >
                    <div class="papers-img">
                        <img :src="suppor_icon[item.id]" alt class="paper-info" />
                        <div
                            class="papered"
                            :class="{'papered-active':params.suppor.indexOf(item.id) != '-1'}"
                        ></div>
                    </div>
                    <div class="paper-tip">{{item.name}}</div>
                </li>
            </ul>
        </div>
        <!-- 地图选址 -->
        <iframe src="/map" class="map-iframe" v-if="page == 5" ref="iframe"></iframe>

        <div class="none" v-if="page == 1 || page == 2"></div>
        <div
            class="btn"
            v-if="page == 1"
            @click="btntap('next')"
            v-show="flag"
            :class="{'active-btn':iosnav}"
        >
            <div class="btn-name">下一步</div>
            <p>更多信息和推荐标签</p>
        </div>
        <div
            class="btn"
            v-if="page == 2"
            @click="publisShop"
            v-show="flag"
            :class="{'active-btn':iosnav}"
        >
            <div class="submit">提交发布</div>
        </div>
        <div
            class="btn"
            v-if="page == 3"
            @click="btntap('papersure')"
            :class="{'active-btn':iosnav}"
        >
            <div class="submit">确定</div>
        </div>
        <div
            class="btn"
            v-if="page == 4"
            @click="btntap('supporsure')"
            :class="{'active-btn':iosnav}"
        >
            <div class="submit">确定</div>
        </div>
        <!-- <div class="btn" v-if="page == 5" @click="btntap('mapsure')">
            <div class="submit">确定</div>
        </div>-->
        <!-- 弹窗 -->
        <mt-popup v-model="popupVisible" position="bottom">
            <!-- 商铺类型 -->
            <div class="shopType" v-show="optionsType == 'type'">
                <div class="popup-title">(商业类型)</div>
                <div class="option-box">
                    <ul class="options">
                        <li
                            class="option-item"
                            v-for="item in options.type"
                            @click="changeOption(item.id,item.name)"
                            :class="{'item-active':item.id == params.type}"
                        >{{item.name}}</li>
                    </ul>
                </div>
            </div>
            <!-- 付款方式 -->
            <div class="shopType" v-show="optionsType == 'payType'">
                <div class="popup-title display_flex">
                    <span>(押)</span>
                    <span>(付)</span>
                </div>
                <div class="option-box display_flex">
                    <ul class="options">
                        <li
                            class="option-item payOption"
                            v-for="item in options.yaType"
                            @click="changeOption(item.id,item.name,'ya')"
                            :class="{'left-active':item.id == params.pay_ya}"
                        >{{item.name}}</li>
                    </ul>
                    <ul class="options">
                        <li
                            class="option-item"
                            v-for="item in options.fuType"
                            @click="changeOption(item.id,item.name,'fu')"
                            :class="{'item-active':item.id == params.pay_fu}"
                        >{{item.name}}</li>
                    </ul>
                </div>
            </div>
            <!-- 商圈选择 -->
            <div class="shopType" v-show="optionsType == 'areaType'">
                <div class="popup-title display_flex">
                    <span>(城区)</span>
                    <span>(商圈)</span>
                </div>
                <div class="option-box display_flex">
                    <ul class="options">
                        <li
                            class="option-item payOption"
                            v-for="item in options.areas"
                            @click="changeOption(item.id,item.name,1,item.childList)"
                            :class="{'left-active':item.id == params.area_id}"
                        >{{item.name}}</li>
                    </ul>
                    <ul class="options">
                        <li
                            class="option-item"
                            v-for="item in showOptions.areaChilds"
                            @click="changeOption(item.childId,item.childName,2)"
                            :class="{'item-active':item.childId == params.business_area_id}"
                        >{{item.childName}}</li>
                    </ul>
                </div>
            </div>
            <!-- 经营业态 -->
            <div class="shopType" v-show="optionsType == 'formatType'">
                <div class="popup-title">(当前经营)</div>
                <div class="option-box display_flex">
                    <ul class="options">
                        <li
                            class="option-item payOption"
                            v-for="item in options.shopBusinessTypes"
                            @click="changeOption(item.id,item.name,1,item.childList)"
                            :class="{'left-active':item.id == params.parent_manage_type_id}"
                        >{{item.name}}</li>
                    </ul>
                    <ul class="options">
                        <li
                            class="option-item"
                            v-for="item in showOptions.manageChilds"
                            @click="changeOption(item.childId,item.childName,2)"
                            :class="{'item-active':item.childId == params.son_manage_type_id}"
                        >{{item.childName}}</li>
                    </ul>
                </div>
            </div>
            <!-- 所在楼层，总楼层 -->
            <div class="shopType" v-show="optionsType == 'floorType'">
                <div class="popup-title display_flex">
                    <span>(所在楼层)</span>
                    <span>(总楼层)</span>
                </div>
                <div class="option-box display_flex">
                    <ul class="options">
                        <li
                            class="option-item floorType display_flex align-center"
                            v-for="item in options.floor"
                            @click="changeOption(item.id,item.value,'floor')"
                            :class="{'item-active':params.floor.indexOf(item.id) != '-1' }"
                        >
                            <div class="floor-box">
                                <img
                                    src="../../../static/images/publish/mored.png"
                                    alt
                                    v-show="params.floor.indexOf(item.id) != '-1'"
                                    class="floor-icon"
                                />
                            </div>
                            <span>{{item.value}}</span>
                        </li>
                    </ul>
                    <ul class="options">
                        <li
                            class="option-item count-floor"
                            v-for="item in options.countFloor"
                            @click="changeOption(item.id,item.value,'count')"
                            :class="{'item-active':item.id == params.count_floor}"
                            v-if="+item.id >= countIndex"
                        >{{item.value}}</li>
                    </ul>
                </div>
            </div>
        </mt-popup>
    </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      title: "发布商铺",
      page: 1,
      tip: "基本信息",
      popupVisible: false,
      optionsType: "",
      options: "",
      active: "",
      priceType: "0",
      flag: true,
      countIndex: -2,
      suppor_icon: {
        "1": require("../../../static/images/publish/y.png"),
        "2": require("../../../static/images/publish/x.png"),
        "3": require("../../../static/images/publish/b.png"),
        "4": require("../../../static/images/publish/c.png"),
        "5": require("../../../static/images/publish/t.png"),
        "6": require("../../../static/images/publish/s.png"),
        "7": require("../../../static/images/publish/h.png"),
        "8": require("../../../static/images/publish/y.png"),
        "9": require("../../../static/images/publish/q.png"),
        "10": require("../../../static/images/publish/v.png"),
        "11": require("../../../static/images/publish/zz.png"),
        "12": require("../../../static/images/publish/wl.png"),
        "13": require("../../../static/images/publish/cn.png"),
        "14": require("../../../static/images/publish/yw.png"),
        "15": require("../../../static/images/publish/zx.png")
      },
      showOptions: {
        type: "",
        pay_ya: "",
        pay_fu: "",
        areaName: "",
        business_area_name: "",
        areaChilds: "",
        turn: "",
        parent_manage_type_name: "",
        floor_name: [],
        count_floor_name: "",
        license_name: [],
        suppor_name: [],
        manageChilds: "",
        son_manage_type_name: ""
      },
      params: {
        cityId: "",
        type: "",
        monthly_rent: "",
        pay_ya: "",
        pay_fu: "",
        business_area_id: "",
        transfer_fee: "",
        parent_manage_type_id: "",
        floor: [],
        count_floor: "",
        new_license: [],
        suppor: [],
        characteristic: [],
        introduce: "",
        title: "",
        imgs: [],
        real_address: "",
        phone: "",
        build_area: "",
        positionx: "",
        positiony: "",
        son_manage_type_id: "",
        area_id: ""
      },
      fiels: [],
      ossData: "",
      iosnav: false
    };
  },
  mounted() {
    // document.querySelector('body').setAttribute('style', 'width:100%;')
    this.getOssData();
    // iPhone X、iPhone XS
    var isIPhoneX =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 3 &&
      window.screen.width === 375 &&
      window.screen.height === 812;
    // iPhone XS Max
    var isIPhoneXSMax =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 3 &&
      window.screen.width === 414 &&
      window.screen.height === 896;
    // iPhone XR
    var isIPhoneXR =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 2 &&
      window.screen.width === 414 &&
      window.screen.height === 896;

    if (this.$route.query.app == "ios") {
      // if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
        this.iosnav = true;
      // }
      this.params.phone = this.$route.query.paramPhone;
      this.params.cityId = this.$route.query.cityId;
    } else if (this.$route.query.app == "android") {
      this.iosnav = true;
      this.params.phone = this.$route.query.paramPhone;
      this.params.cityId = this.$route.query.cityId;
    } else {
      this.params.phone = localStorage.iphone;
      this.params.cityId = sessionStorage.cityId || 110100;
    }
    this.getOption();
    var that = this;
    window.addEventListener("message", function(e) {
      if (e.data.page) {
        that.params.real_address = e.data.address;
        that.page = e.data.page;
        that.tip = e.data.tip;
        that.title = e.data.title;
        that.params.positiony = e.data.point.lat;
        that.params.positionx = e.data.point.lng;
      }
    });
    if (this.$route.query.app == "ios") {
      window.addEventListener("focusin", () => {
        // 键盘弹出事件处理
        this.flag = false;
      });
      window.addEventListener("focusout", () => {
        // 键盘收起事件处理
        this.flag = true;
      });
    } else if (this.$route.query.app == "android") {
      const innerHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      window.addEventListener("resize", () => {
        const newInnerHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        if (innerHeight > newInnerHeight) {
          this.flag = false;
        } else {
          // 键盘收起事件处理
          this.flag = true;
        }
      });
    }
  },
  methods: {
    //返回
    goback() {
      Indicator.close();
      if (this.page == 1) {
        if (this.$route.query.page == "index") {
          if (this.$route.query.app == "ios") {
            //ios交互的返回方法
            window.webkit.messageHandlers.currentCookiesBack.postMessage({
              body: "buttonActionMessage"
            });
          }
          if (this.$route.query.app == "android") {
            //android返回方法
            AndroidDial.showToast("1");
          }
        } else {
          this.$router.go(-1);
        }
      } else if (this.page == 2) {
        this.page = 1;
      } else if (this.page == 3) {
        this.page = 2;
        this.tip = "更多信息和标签";
        this.title = "发布商铺";
        if (this.showOptions.license_name.length == 0) {
          this.showOptions.license_name.push("暂无证照");
        }
      } else if (this.page == 4) {
        this.page = 2;
        this.tip = "更多信息和标签";
        this.title = "发布商铺";
        if (this.showOptions.suppor_name.length == 0) {
          this.showOptions.suppor_name.push("暂无配套设施");
        }
      } else if (this.page == 5) {
        this.page = 1;
        this.tip = "基本信息";
        this.title = "发布商铺";
      }
    },
    preview(imgs, index) {
      ImagePreview({
        images: imgs,
        showIndex: true,
        loop: false, //是否循环播放
        startPosition: index
      });
    },
    btntap(type) {
      if (type == "next") {
        if (this.priceType == "0") {
          this.params.transfer_fee = "面议";
        } else if (this.priceType == "1") {
          if (!this.showOptions.turn) {
            Toast("请填写转让费");
            return;
          }
          this.params.transfer_fee = this.showOptions.turn;
        }
        if (!this.params.type) {
          Toast("请选择商铺类型");
          return;
        }
        if (!this.params.build_area) {
          Toast("请输入商铺面积");
          return;
        }
        if (+this.params.build_area <= 0 || +this.params.build_area > 99999) {
          Toast("面积范围为1 ~ 99999");
          return;
        }
        if (!this.params.monthly_rent) {
          Toast("请填写月租金");
          return;
        }
        if (
          +this.params.monthly_rent <= 0 ||
          +this.params.monthly_rent > 999999
        ) {
          Toast("月租金范围为1 ~ 999999");
          return;
        }

        if (!this.params.pay_ya || !this.params.pay_fu) {
          Toast("请选择付款方式");
          return;
        }
        if (!this.params.real_address) {
          Toast("请选择地址");
          return;
        }
        if (!this.params.business_area_id) {
          Toast("请选择商圈");
          return;
        }
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.page = 2;
        this.tip = "更多信息和标签";
      } else if (type == "papersure") {
        this.page = 2;
        this.tip = "更多信息和标签";
        this.title = "发布商铺";
        if (this.showOptions.license_name.length == 0) {
          this.showOptions.license_name.push("暂无证照");
        }
      } else if (type == "supporsure") {
        this.page = 2;
        this.tip = "更多信息和标签";
        this.title = "发布商铺";
        if (this.showOptions.suppor_name.length == 0) {
          this.showOptions.suppor_name.push("暂无配套设施");
        }
      } else if (type == "mapsure") {
        this.page = 1;
        this.tip = "基本信息";
        this.title = "发布商铺";
      }
    },
    //获取发铺字典
    getOption() {
      this.$http({
        url: this.changeData() + "/receive/getShopJson",
        method: "POST",
        params: {
          cityId: this.params.cityId
        }
      }).then(res => {
        if (res.data.code == "101") {
          this.options = res.data.data;
          this.params.area_id = res.data.data.areas[0].id;
          this.showOptions.areaChilds = res.data.data.areas[0].childList;
          this.params.parent_manage_type_id =
            res.data.data.shopBusinessTypes[1].id;
          this.showOptions.manageChilds =
            res.data.data.shopBusinessTypes[1].childList;
          this.params.pay_ya = res.data.data.yaType[1].id;
          this.params.pay_fu = res.data.data.fuType[0].id;
          this.params.floor.push(res.data.data.floor[1].id);
          this.options.countFloor = res.data.data.floor;
        }
      });
    },
    //显示弹窗
    showPopup(showType) {
      $(".info-box").blur();
      if (showType == "paperType") {
        this.title = "点击选择已有证照";
        this.tip = "";
        this.page = 3;
      } else if (showType == "supporType") {
        this.title = "点击选择商铺配套";
        this.tip = "";
        this.page = 4;
      } else if (showType == "mapType") {
        this.title = "标记商铺地址";
        this.tip = "";
        this.page = 5;
      } else {
        this.popupVisible = true;
      }
      if (showType == "areaType" && !this.showOptions.areaName) {
        this.showOptions.areaName = this.options.areas[0].name + " · ";
      }
      if (
        showType == "formatType" &&
        !this.showOptions.parent_manage_type_name
      ) {
        this.showOptions.parent_manage_type_name =
          this.options.shopBusinessTypes[1].name + " · ";
      }
      if (showType == "payType") {
        if (!this.showOptions.pay_ya) {
          this.showOptions.pay_ya = this.options.yaType[1].name;
        }
        if (!this.showOptions.pay_fu) {
          this.showOptions.pay_fu = this.options.fuType[0].name;
        }
      }
      if (showType == "floorType") {
        if (this.showOptions.floor_name.length == 0) {
          this.showOptions.floor_name.push(this.options.floor[1].value);
        }
      }
      this.optionsType = showType;
    },
    focus(type) {
      this.active = type;
      if (type == "turn") {
        this.priceType = "1";
      }
    },
    blur() {
      if (this.active == "title" && this.params.title.length < 10) {
        Toast("标题字数不得少于10个字");
      }
      this.active = "";
    },
    radioChange() {
      this.showOptions.turn = "";
      this.params.transfer_fee = "";
    },
    changeOption(id, name, type, childs) {
      switch (this.optionsType) {
        case "type":
          this.params.type = id;
          this.showOptions.type = name;
          this.popupVisible = false;
          break;

        case "payType":
          if (type == "ya") {
            this.params.pay_ya = id;
            this.showOptions.pay_ya = name;
          } else {
            this.params.pay_fu = id;
            this.showOptions.pay_fu = name;
            this.popupVisible = false;
          }
          break;
        case "areaType":
          if (type == 1) {
            this.params.area_id = id;
            this.showOptions.areaName = name + " · ";
            this.showOptions.areaChilds = childs;
            this.showOptions.business_area_name = "";
            this.params.business_area_id = "";
          } else if (type == 2) {
            this.showOptions.business_area_name = name;
            this.params.business_area_id = id;
            this.popupVisible = false;
          }
          break;
        case "formatType":
          if (type == 1) {
            this.showOptions.parent_manage_type_name = name + " · ";
            this.params.parent_manage_type_id = id;
            this.showOptions.manageChilds = childs;
            this.params.son_manage_type_id = "";
            this.showOptions.son_manage_type_name = "";
          } else if (type == 2) {
            this.params.son_manage_type_id = id;
            this.showOptions.son_manage_type_name = name;
            this.popupVisible = false;
          }

          break;
        case "floorType":
          if (type == "floor") {
            if (this.params.floor.indexOf(id) == "-1") {
              this.showOptions.floor_name.push(name);
              this.params.floor.push(id);
              this.countIndex = Math.max.apply(null,this.params.floor)
              this.options.countFloor = this.options.floor;
            } else {
              this.params.floor.splice(this.params.floor.indexOf(id), 1);
              this.showOptions.floor_name.splice(
                this.showOptions.floor_name.indexOf(name),
                1
              );
              this.countIndex = Math.max.apply(null,this.params.floor)
              this.options.countFloor = this.options.floor;
            }
          } else {
            this.showOptions.count_floor_name = name;
            this.params.count_floor = id;
            this.popupVisible = false;
          }

          break;
        case "paperType":
          if (this.showOptions.license_name[0] == "暂无证照") {
            this.showOptions.license_name = [];
          }
          if (this.params.new_license.indexOf(id) == "-1") {
            this.showOptions.license_name.push(name);
            this.params.new_license.push(id);
          } else {
            this.params.new_license.splice(
              this.params.new_license.indexOf(id),
              1
            );
            this.showOptions.license_name.splice(
              this.showOptions.license_name.indexOf(name),
              1
            );
          }
          break;
        case "supporType":
          if (this.showOptions.suppor_name[0] == "暂无配套设施") {
            this.showOptions.suppor_name = [];
          }
          if (this.params.suppor.indexOf(id) == "-1") {
            this.showOptions.suppor_name.push(name);
            this.params.suppor.push(id);
          } else {
            this.params.suppor.splice(this.params.suppor.indexOf(id), 1);
            this.showOptions.suppor_name.splice(
              this.showOptions.suppor_name.indexOf(name),
              1
            );
          }
          break;
      }
    },
    // 选择标签
    changeTag(id) {
      if (this.params.characteristic.indexOf(id) == "-1") {
        if (this.params.characteristic.length < 10) {
          this.params.characteristic.push(id);
        }
      } else {
        this.params.characteristic.splice(
          this.params.characteristic.indexOf(id),
          1
        );
      }
    },
    //上传图片
    //1.获取oss配置参数
    getOssData() {
      this.$http({
        url: this.changeData() + "/oss/policy",
        method: "post"
      })
        .then(res => {
          this.ossData = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //2.上传图片到阿里云oss
    updata(e) {
      Indicator.open("图片上传中...");
      var file = e.target.files;
      var that = this;
      for (let i = 0; i < file.length; i++) {
        var upData = new FormData();
        upData.append("OSSAccessKeyId", that.ossData.accessid);
        upData.append("policy", that.ossData.policy);
        upData.append("Signature", that.ossData.signature);
        upData.append("key", that.ossData.dir + that.random_string(32));
        upData.append("success_action_status", 200); // 指定返回的状态码
        upData.append("callback", that.ossData.callback);
        upData.append("file", file[i]);
        this.$http
          .post(that.ossData.host, upData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(res => {
            if (that.params.imgs.length < 10) {
              that.params.imgs.push(
                res.request.responseURL + res.data.fileName
              );
            } else {
              Indicator.close();
            }

            if (i == file.length - 1) {
              Indicator.close();
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456789";
      var maxPos = chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    deleteImg(index) {
      this.params.imgs.splice(index, 1);
    },
    //发布
    publisShop() {
      if (!this.params.son_manage_type_id) {
        Toast("请选择当前经营业态");
        return;
      }
      if (this.showOptions.license_name.length == 0) {
        this.showOptions.license_name.push("暂无证照");
      }
      if (this.params.floor.length == 0) {
        Toast("请选择商铺所在楼层");
        return;
      }
      if (!this.params.count_floor) {
        Toast("请选择总楼层");
        return;
      }
      if (this.showOptions.suppor_name.length == 0) {
        this.showOptions.suppor_name.push("暂无配套设施");
      }
      if (!this.params.title) {
        Toast("请输入商铺标题");
        return;
      }
      if (this.params.title.length < 10 || this.params.title.length > 40) {
        Toast("商铺标题字数 10 ～ 40");
        return;
      }
      if (!this.params.introduce) {
        Toast("请输入描述");
        return;
      }
      if (this.params.characteristic.length == 0) {
        Toast("请选择特色标签");
        return;
      }
      this.$http({
        url: this.changeData() + "/receive/receiveShop",
        method: "POST",
        params: {
          cityId: this.params.cityId,
          type: this.params.type,
          monthly_rent: this.params.monthly_rent,
          pay_ya: this.params.pay_ya,
          pay_fu: this.params.pay_fu,
          real_address: this.params.real_address,
          business_area_id: this.params.business_area_id,
          transfer_fee: this.params.transfer_fee,
          parent_manage_type_id: this.params.parent_manage_type_id,
          son_manage_type_id: this.params.son_manage_type_id,
          floor: this.params.floor.join(","),
          count_floor: this.params.count_floor,
          new_license: this.params.new_license.join(","),
          suppor: this.params.suppor.join(","),
          characteristic: this.params.characteristic.join(","),
          introduce: this.params.introduce,
          title: this.params.title,
          imgs: this.params.imgs.join(",") || "https://up-img.oss-cn-beijing.aliyuncs.com/default.jpg",
          phone: this.params.phone,
          build_area: this.params.build_area,
          positionx: this.params.positionx,
          positiony: this.params.positiony,
          userId: this.$route.query.userId,
          area_id: this.params.area_id
        }
      }).then(res => {
        if (res.data.code == "101") {
          if (this.$route.query.app == "ios") {
            this.$router.push({
              path: "/zhuanpudetail",
              query: {
                shopId: res.data.id,
                userId: this.$route.query.userId,
                cityId: this.$route.query.cityId,
                paramPhone: this.$route.query.paramPhone,
                app: "ios"
              }
            });
          } else if (this.$route.query.app == "android") {
            this.$router.push({
              path: "/zhuanpudetail",
              query: {
                shopId: res.data.id,
                userId: this.$route.query.userId,
                cityId: this.$route.query.cityId,
                paramPhone: this.$route.query.paramPhone,
                app: "android"
              }
            });
          }
        } else {
          Toast(res.data.message);
        }
      });
    },
    inquiry() {
      if (this.$route.query.app == "ios") {
        window.webkit.messageHandlers.currentCookies.postMessage({
          body: "buttonActionMessage"
        });
      } else if (this.$route.query.app == "android") {
        AndroidDial.showToast("2");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../static/css/publishop.scss";
</style>



// WEBPACK FOOTER //
// src/components/publish/publishop.vue